/**
 *
 * Created Date: 2019-06-18, 21:17:00 (zhenliang.sun)
 * Last Modified: 2019-06-18, 22:00:49 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

/**
 *
 *
 * @export
 * @class ActivatedInfo
 */
export default class ActivatedInfo {
  constructor() {
    this.cid = '';
    this.activatedTime = -1;
  }
}
